import React, {useState} from "react";

import * as functionHelper from '../common/functions';

const ItemNamePartialComponent = ({item}) => {

  const uniqueSeries = functionHelper.getUniqueSeriesNames(item.series);
  const date = new Date(item.dates.createdAt)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są liczone od 0, dlatego dodajemy 1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return(
    <React.Fragment>
     <ul className="list-inline seriesList">
      {
        uniqueSeries.map((series, key) => {
          return (
            <React.Fragment key={key}>
              <li className="list-inline-item">{series}</li>
            </React.Fragment>
           );
        })
      }
      </ul>
      <strong>{item.name}</strong><br/><small>Data ostatniej aktualizacji: <strong>{year}-{month}-{day} {hours}:{minutes}</strong></small>    
    </React.Fragment>
  )

}
export default ItemNamePartialComponent;